import React, { FC, ReactElement, useState } from 'react';

import { TabList as MuiTabList, TabPanel as MuiTabPanel } from '@mui/lab';
import { Box, Tab as MuiTab, TabProps as MuiTabProps } from '@mui/material';

import { ConditionalTabContext } from './ConditionalTabContext';
import { tabStyleSx } from './style';

interface TabsContentProps extends Omit<MuiTabProps, 'content'> {
  content?: ReactElement | string;
}

interface TabsProps {
  tabsContent: Array<TabsContentProps>;
  scrollable?: boolean;
}

export const Tabs: FC<TabsProps> = ({ tabsContent, scrollable }) => {
  const [activeTab, setActiveTab] = useState('0');

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(`${newValue}`);
  };

  return (
    <ConditionalTabContext value={activeTab}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <MuiTabList
          sx={tabStyleSx}
          onChange={handleChange}
          aria-label="Navigation tabs list"
          variant={scrollable ? 'scrollable' : 'standard'}
          scrollButtons="auto"
        >
          {/* eslint-disable-next-line @typescript-eslint/no-unused-vars */}
          {tabsContent.map(({ content, ...tabProps }, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <MuiTab key={index} value={`${index}`} {...tabProps} />
          ))}
        </MuiTabList>
      </Box>
      {tabsContent.map(({ content }, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <MuiTabPanel key={index} value={`${index}`}>
          {content}
        </MuiTabPanel>
      ))}
    </ConditionalTabContext>
  );
};
